module.exports = __webpack_public_path__ + "92bba608c7c59aa83d9b021dc93f5abe.pdf";